// src/components/Documentation/components/CodeBlock.jsx
import React, { useState } from 'react';
import { getCodeExample } from '../data/codeExamples';
import { languages, defaultLanguage } from '../data/languages';

const CodeBlock = ({ section }) => {
  const [copied, setCopied] = useState(false);
  const [selectedLang, setSelectedLang] = useState(defaultLanguage);

  // Safely get the code with fallback
  const code = getCodeExample(section, selectedLang);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  // Determine language for syntax highlighting
  const getLanguageClass = (lang) => {
    const languageMap = {
      curl: 'bash',
      node: 'javascript',
      python: 'python',
      php: 'php',
      ruby: 'ruby',
      go: 'go'
    };
    return languageMap[lang] || 'bash';
  };

  return (
    <div className="relative group my-4">
      <div className="flex items-center justify-between bg-gray-800 px-4 py-2 rounded-t-lg">
        {/* Language Selector - Per Code Block */}
        <div className="flex items-center gap-2">
          {Object.entries(languages).map(([key, label]) => (
            <button
              key={key}
              onClick={() => setSelectedLang(key)}
              className={`px-3 py-1 text-xs font-medium rounded transition-colors ${
                selectedLang === key
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
              }`}
            >
              {label}
            </button>
          ))}
        </div>

        {/* Copy Button */}
        <button
          onClick={copyToClipboard}
          className="text-sm text-gray-300 hover:text-white transition-colors flex items-center gap-2"
        >
          {copied ? (
            <>
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Copied!
            </>
          ) : (
            <>
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
              Copy
            </>
          )}
        </button>
      </div>
      <pre className="bg-gray-900 p-4 rounded-b-lg overflow-x-auto">
        <code className={`language-${getLanguageClass(selectedLang)} text-sm text-gray-100`}>
          {code}
        </code>
      </pre>
    </div>
  );
};

export default CodeBlock;